<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style lang="less">
body {
    margin: 0;
    h2 {
        margin: 0;
    }
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 14px;
}
/* 滚动条 */
::-webkit-scrollbar-thumb:horizontal {
    /*水平滚动条的样式*/
    width: 5px;
    background-color: #aaa;
    -webkit-border-radius: 10px;
    outline: 2px solid #efefef;
    outline-offset: 0px;
    border: 3px solid #efefef;
}
::-webkit-scrollbar-track-piece {
    background-color: #efefef; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
}
::-webkit-scrollbar {
    width: 10px; /*滚动条的宽度*/
    height: 14px; /*滚动条的高度*/
}
::-webkit-scrollbar-thumb:vertical {
    /*垂直滚动条的样式*/
    height: 50px;
    background-color: #aaa;
    -webkit-border-radius: 10px;
    outline: 2px solid #efefef;
    outline-offset: -2px;
    border: 2px solid #efefef;
}
::-webkit-scrollbar-thumb:hover {
    /*滚动条的hover样式*/
    height: 50px;
    background-color: #999;
    -webkit-border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue